import { Factory } from './Factory'
import { RowFactory} from './RowFactory'
import Menu from '../EditorElements/SectionModule/Menu'

export class SectionFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create(data) {
    this.sections = this.mapSections(data)
    let sections = this.sections.map(section => {
      let id = this.id('section')
      return {id, ...section}
    })
    return sections
  }

  mapSections(data = {}) {
    let sections = []
    for (let x = 1; x <= this.qty; x++) {
      sections.push({...this.markup(x), ...data})
    }
    return sections
  }

  markup() {
    return {
      properties: {
        styles: [
          {key: 'background-color', component:'BackgroundProperty'},
          {key: 'border', component:'BorderProperty'},
          {key: 'height', component:'HeightProperty'},
          {key: 'padding', component:'PaddingProperty'},
          {key: 'display', component: 'DisplayInDeviceProperty'},
        ],
        advanced: [
          {key: 'element-id', component: 'ElementId'},
          {key: 'custom-classes', component: 'CustomClasses'},
          {key: 'custom-styles', component: 'CustomStyles'},
        ],
        menu: Menu
      },
      rows: (new RowFactory).create(),
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      styles: {
        phone: [],
        tablet: [],
        desktop: []
      },
      classes: {
        phone: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        tablet: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        desktop: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ]
      },
      effects: [],
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      name: 'section',
      customClasses: []
    }
  }
}